import { useContext } from "react";
import { EditProductContext } from './EditProductContext'

export const useEditProductContext = () => {
    const context = useContext(EditProductContext);
    if (!context) {
        throw new Error("Must be used within a ModeProvider");
    }
    return context;
};